(() => {
  function enhance(root = document) {
    root.querySelectorAll('.sembonia-footer:not([data-accordion-ready])').forEach(footer => {
      footer.dataset.accordionReady = 'true';
      const mobile = window.matchMedia('(max-width: 809.98px)');
      const groups = [];
      footer.querySelectorAll('.footer-block--menu, .footer-custom-information > div').forEach((group, index) => {
        const heading = group.querySelector('.footer-block__heading');
        if (!heading) return;
        const panel = document.createElement('div');
        panel.className = 'sembonia-footer__panel';
        panel.id = `${footer.closest('.shopify-section').id}-panel-${index}`;
        while (heading.nextSibling) panel.append(heading.nextSibling);
        group.append(panel);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sembonia-footer__toggle';
        while (heading.firstChild) button.append(heading.firstChild);
        button.setAttribute('aria-controls', panel.id);
        heading.replaceChildren(button);
        button.addEventListener('click', () => {
          if (!mobile.matches) return;
          panel.hidden = !panel.hidden;
          button.setAttribute('aria-expanded', String(!panel.hidden));
        });
        groups.push({button, panel});
      });
      const update = () => groups.forEach(({button, panel}) => {
        panel.hidden = mobile.matches;
        button.disabled = !mobile.matches;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      });
      update();
      mobile.addEventListener('change', update);
      const unload = event => {
        if (!event.target.contains(footer)) return;
        mobile.removeEventListener('change', update);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), {once:true});
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
